import { render, staticRenderFns } from "./CreditLimitReport.vue?vue&type=template&id=bc3eea46&"
import script from "./CreditLimitReport.vue?vue&type=script&lang=js&"
export * from "./CreditLimitReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports